import script from "./VVVWithdrawManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVWithdrawManagement.vue?vue&type=script&setup=true&lang=js"

import "./VVVWithdrawManagement.vue?vue&type=style&index=0&id=7922c7f4&scoped=true&lang=css"
import "./VVVWithdrawManagement.vue?vue&type=style&index=1&id=7922c7f4&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7922c7f4"]])

export default __exports__